<script lang="ts">
  import ArrowUpRight from "@lucide/svelte/icons/arrow-up-right";

  import logotypeDark from "$lib/assets/logotype-dark.svg";
  import logotype from "$lib/assets/logotype.svg";

  type Props = {
    isLightTheme: boolean;
  };

  let { isLightTheme }: Props = $props();
</script>

<!-- Semantic colors set this apart from the glossary's own palette. The route
     is pinned dark, so data-theme follows the glossary's light theme instead. -->
<a
  href="/signup"
  class="group mt-8 mb-2 cursor-pointer!"
  data-theme={isLightTheme ? "light" : "dark"}
>
  <div
    class="animate-border marketing-cta flex flex-col items-end justify-between gap-6 rounded-lg border border-transparent p-4 font-goga transition-all duration-300 ease-out group-hover:scale-[101%] md:flex-row"
  >
    <div>
      <img src={logotype} alt="Modal" class="logotype logotype-default" />
      <img src={logotypeDark} alt="Modal" class="logotype logotype-light" />
      <div>
        <hgroup class="space-y-0">
          <h2 class="text-md flex items-center font-medium text-balance">
            Building on GPUs? We know a thing or two about it.
          </h2>
          <p class="cta-subtitle font-sans text-sm md:text-balance">
            Modal is an ergonomic Python SDK wrapped around a global GPU fleet.<span
              class="hidden xl:inline"
            >
              &nbsp;Deploy serverless AI workloads instantly without worrying
              about quota requests, driver compatibility issues, or managing
              bulky ML dependencies.
            </span>
          </p>
        </hgroup>
      </div>
      <p class="hidden">
        Deploy serverless AI workloads instantly without worrying about quota
        requests, driver compatibility issues, or managing bulky ML
        dependencies.
      </p>
    </div>
    <div>
      <div
        class="cta-link flex items-center gap-1.5 font-sans text-sm whitespace-nowrap"
      >
        Deploy on GPUs
        <span
          class="z-10 inline-block h-4 w-4 rounded-full bg-accent-bold p-0.5"
          ><ArrowUpRight
            size={14}
            class="h-full w-full icon-accent-bold"
          /></span
        >
      </div>
    </div>
  </div>
</a>

<style lang="postcss">
  @reference "$app.css";

  @property --border-angle {
    inherits: false;
    initial-value: 0deg;
    syntax: "<angle>";
  }

  @keyframes border {
    to {
      --border-angle: 360deg;
    }
  }

  .animate-border {
    animation: border 5s linear infinite;
  }

  .logotype {
    height: 14px;
    margin-bottom: 12px;
  }

  .logotype-light {
    display: none;
  }

  :global([data-theme="light"]) .logotype-default {
    display: none;
  }

  :global([data-theme="light"]) .logotype-light {
    display: block;
  }

  @layer components {
    .marketing-cta {
      color: var(--semantic-text-primary);
      background:
        linear-gradient(
            45deg,
            var(--semantic-background-elevated),
            var(--semantic-background-secondary) 50%,
            var(--semantic-background-elevated)
          )
          padding-box,
        conic-gradient(
            from var(--border-angle),
            var(--semantic-border-primary) 80%,
            var(--semantic-border-accent-hover) 86% 94%,
            var(--semantic-border-primary)
          )
          border-box;
    }

    :global(.group:hover) .marketing-cta {
      border-color: var(--semantic-border-accent-hover);
    }

    .marketing-cta .cta-subtitle {
      color: var(--semantic-text-secondary);
    }

    .marketing-cta .cta-link {
      color: var(--semantic-text-accent);
      transition: transform 0.2s ease;
    }

    :global(.group:hover) .marketing-cta .cta-link {
      color: var(--semantic-text-accent-hover);
      transform: scale(1.1);
      transform-origin: bottom right;
    }
  }
</style>
